import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Building2 } from "lucide-react";
import { api } from "../lib/api";

const isExternal = (url) => /^https?:\/\//i.test(url || "");

const Footer = () => {
  const [links, setLinks] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const s = await api.getSettings();
        const fl = Array.isArray(s?.footer_links) ? s.footer_links : [];
        setLinks(fl);
      } catch { /* ignore */ }
    })();
  }, []);

  return (
    <footer className="mt-20 border-t border-white/10 bg-[#0a0d12]">
      <div className="mx-auto max-w-7xl px-4 py-10 grid grid-cols-1 md:grid-cols-3 gap-8">
        <div>
          <div className="flex items-center gap-2">
            <div className="flex h-8 w-8 items-center justify-center rounded-md bg-gradient-to-br from-[#7c4dff] to-[#ff9800]">
              <Building2 className="h-4 w-4 text-white" />
            </div>
            <span className="pixel-text text-sm text-white">HABTHEK</span>
          </div>
          <p className="mt-3 text-sm text-zinc-400">
            Inoffizielle Fanseite über die Historie von Habbo.de. Nicht mit Sulake / Azerion verbunden.
          </p>
        </div>
        <div>
          <h4 className="text-sm font-semibold text-white">Inhalt</h4>
          <ul className="mt-3 space-y-2 text-sm text-zinc-400" data-testid="footer-content-links">
            {links.length === 0 && (
              <li className="text-xs text-zinc-600 italic">Noch keine Links – im Admin-Dashboard hinzufügen.</li>
            )}
            {links.map((l, i) => (
              <li key={i}>
                {isExternal(l.to) ? (
                  <a href={l.to} target="_blank" rel="noreferrer" className="hover:text-white">{l.label}</a>
                ) : (
                  <Link to={l.to} className="hover:text-white">{l.label}</Link>
                )}
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="text-sm font-semibold text-white">Rechtliches</h4>
          <ul className="mt-3 space-y-2 text-sm text-zinc-400">
            <li><Link to="/impressum" data-testid="footer-impressum" className="hover:text-white">Impressum</Link></li>
            <li><Link to="/datenschutz" data-testid="footer-datenschutz" className="hover:text-white">Datenschutz</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5 py-4 text-center text-xs text-zinc-500">
        © {new Date().getFullYear()} Habthek – Habbo™ ist eine Marke von Sulake / Azerion.
      </div>
    </footer>
  );
};

export default Footer;
